import { useDispatch } from 'react-redux';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { closeModal } from '../../reducers/modal';

const ConfirmDownload = ({ styles }) => {
  const dispatch = useDispatch();
  const handleDownload = () => {
    window.open('https://storage.googleapis.com/mbi-broadband-public/DemoDigitalEquityVariablesACSEstimates.csv', '_blank');
    dispatch(closeModal());
  };
  const onClose = () => {
    dispatch(closeModal());
  };

  return (
    <>
      <DialogTitle id="responsive-dialog-title" style={styles.title}>Confirm</DialogTitle>
      <DialogContent style={styles.content}>
        <Typography>Are you sure you want to download demographics table for the entire state?</Typography>
      </DialogContent>
      <DialogActions style={styles.content}>
        <Button color="primary" variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleDownload}>
          Confirm
        </Button>
      </DialogActions>

    </>
  );
};
export default ConfirmDownload;
